import { styled } from "@acko-tech/building-blocks.ui.common";
import { device } from "@utils/screens";

export const Container = styled.div`
  height: max-content;
  width: 100%;
  padding-bottom: 32px;
`;

export const AddressContainer = styled.div`
  position: relative;
  z-index: 1;
  background-color: #f8f7fc;
  margin: 0 32px;
  border-radius: 8px;
  overflow: hidden;
  @media ${device.tablet} {
    margin: 0;
  }
`;

export const AddressContent = styled.div`
  padding: 20px;
`;

export const DeliveryEstimate = styled.p`
  margin: 0;
  padding: 10px 20px;
  background-color: #efedf6;
  font-family: Euclid Circular B;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: var(--text-secondary-n-400, #5B5675);
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const AddressTitle = styled.p`
  margin: 0;
  font-family: Euclid Circular B;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  margin-right: 20px;
  margin-bottom: 8px;
  color: #040222;
`;

export const EditButton = styled.p`
  margin: 0;
  font-family: Euclid Circular B;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #1b73e8;
  cursor: pointer;
`;

export const FullAddress = styled.p`
  margin: 0;
  font-family: Euclid Circular B;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  margin-right: 30px;
  color: #5b5675;
`;

export const Title = styled.p`
  font-family: Euclid Circular B;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.10000000149011612px;
  text-align: left;
  color: #040222;
  margin: 24px 32px 16px 32px;

  @media ${device.tablet} {
    font-size: 16px;
    line-height: 22px;
    margin: 24px 0 16px 0;
  }
`;

export const FormContainer = styled.div`
  margin: 0 32px;

  @media ${device.tablet} {
    margin: 0;
  }
`;
